import Vue from 'vue'
import App from './App'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueRouter from 'vue-router'
import MainInicio from './components/pagina-inicial/MainInicio.vue'
import Obras from './components/pagina-obras/Obras.vue'
import DetalheObra from './components/detalhe-obra/DetalheObra.vue'
import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './vuex/store'


library.add(fas)

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {path: '/', component: MainInicio},
    {path: '/obras', component: Obras},
    {path: '/obra-detalhes/:id', name: 'detalheObra', component: DetalheObra, props:true}
  ]

})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js